import React from 'react';
import accessibleSvg from 'utils/accessibleSvg';

export default accessibleSvg(({ children, ...props }) => (
  <svg fill="currentColor" viewBox="0 0 448.00076 220.21387" {...props}>
    {children}
    <path d="M134.05975 150.10743h301.941c6.627 0 12-5.373 12-12V82.107434c0-6.627-5.373-12-12-12h-301.941v-46.059c0-21.3819996-25.851-32.0899996-40.971-16.9709996L7.02975 93.136434c-9.373 9.372996-9.373 24.568996 0 33.940996l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971z" />
  </svg>
));
